export type NotificationPermissionState = 'default' | 'granted' | 'denied' | 'unsupported'

export function getPermissionState(): NotificationPermissionState {
  if (typeof window === 'undefined' || typeof Notification === 'undefined') return 'unsupported'
  return Notification.permission
}

export async function requestPermission(): Promise<NotificationPermissionState> {
  if (getPermissionState() === 'unsupported') return 'unsupported'
  const result = await Notification.requestPermission()
  return result
}

export interface ShowOpts {
  title: string
  body?: string
  tag?: string
  icon?: string
  onClick?: () => void
}

export function showNotification(opts: ShowOpts): Notification | null {
  if (getPermissionState() !== 'granted') return null
  if (typeof document !== 'undefined' && document.visibilityState === 'visible') {
    return null
  }
  const n = new Notification(opts.title, {
    body: opts.body,
    tag: opts.tag,
    icon: opts.icon ?? '/icons/icon-192.png',
  })
  if (opts.onClick) {
    n.onclick = (e) => {
      e.preventDefault()
      window.focus()
      opts.onClick?.()
      n.close()
    }
  }
  return n
}
